import { Component } from '@angular/core';
import { BaseDetailPageComponent } from 'src/app/components/pages/base-detail-page/base-detail-page.component';
import BaseDetailPageConfig from 'src/app/models/base-detail-page.config';
import { RequestsService } from 'src/app/services/api/requests.service';
import { RouteService } from 'src/app/services/route.service';

@Component({
  selector: 'app-request-categories-detail-page',
  imports: [BaseDetailPageComponent],
  templateUrl: './request-categories-detail-page.component.html',
  styleUrl: './request-categories-detail-page.component.scss'
})
export class RequestCategoriesDetailPageComponent {
 baseDetailPageConfig!: BaseDetailPageConfig;
  readonlyUserDetail: boolean

  requestCategory?: any;

  constructor(
    private requestsService: RequestsService,
    private routeService: RouteService
  ) {
    this.readonlyUserDetail = true
  }

  ngOnInit(): void {

    this.baseDetailPageConfig = {
      pageTitle: 'Request Categories',
      cardTitle: 'Request Categories Detail',
      editItemButton: {
        type: 'success',
        title: 'Edit Category',
        onClick: () => {
          this.routeService.requestsSettingsRequestCategoriesUpdate(this.requestCategory.requestCategoryId)
        }
      },
      dataList: {
        data: null,
        rows: [
          {
            attribute: 'code',
            label: 'Code',
            value: (item: any) => {
              return item.code;
            }
          },
          {
            attribute: 'name',
            label: 'Name',
            value: (item: any) => {
              return item.name;
            }
          },
          {
            attribute: 'createTime',
            label: 'Create Time',
            value: (item: any) => {
              return item.createTime;
            }
          },
        ]
      },
      apiDetailService: (requestCategoryId: number) => this.requestsService.detailSettingsRequestCategories(requestCategoryId),
      routeParamName: 'requestCategoryId',
      responseModelName: 'requestCategory'
    };

  }

  onLoadedDetail(data: any) {
    this.requestCategory = data;
  }
}
